import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/productVariants', request)
}
export {get}
